(function() {
    'use strict';

a3_pilot_reports.controller('TraineeCourseCtrl', TraineeCourseCtrl);
 /**
     * @memberof PilotReports
     * @ngdoc controller
     * @name TraineeCourseCtrl
     * @description 
     *
     * @ngInject
     */
function TraineeCourseCtrl($scope, $routeParams, TraineeCoursesDetailsFactory, TrainingSessionFactory, $location){
    var traineeCourseId = Number($routeParams.traineeCourseId);
    $scope.hasError = false;
    $scope.isLoading = true;
    $scope.courseDate = $routeParams.date;
    $scope.isTraineeView = true;
    $scope.gotoCalendar = gotoCalendar;
    $scope.setSelectedPhase = setSelectedPhase;

    $scope.responseObj = { success: false, message: '', Results: [] };
    $scope.results = [];
    $scope.showWarning = false;

    TraineeCoursesDetailsFactory.getTraineeCourse(traineeCourseId).then(res => handleSubmitResponse(res))
    .catch(res => handleFailedResponse(res)); 

    function handleSubmitResponse(res) {
        $scope.responseObj = res;
        if(res.success){
            $scope.traineeCourse = res.Results.data.traineeCourse;
            $scope.courseDetails = res.Results.data.courseDetails;
    
            $scope.traineeCourse.Phases.forEach(function(phase){
                phase.StatusClass = '';
                 
                if(phase.PhaseStatus=='InProgress'){
                    phase.StatusClass="border-left-blue";
                    phase.TextClass="text-blue";
                     phase.BtnClass="bg-blue text-white";
                }
                else if(phase.PhaseStatus=='Pending'){
                    phase.StatusClass="border-left-gray ";
                    phase.TextClass="text-gray";
                     phase.BtnClass="bg-gray text-white";
                }
                else if(phase.PhaseStatus=='Completed'){
                    phase.StatusClass="border-left-green";
                    phase.TextClass="text-green";
                     phase.BtnClass="bg-green text-white";
                }
        
            });
     
                $scope.traineeCourse.Phases.forEach(function (phase) {
                    phase.Sessions.forEach(function (sessionTrainee) {
                if (sessionTrainee) {
                    $scope.traineeSession = sessionTrainee;
                    $scope.traineeSession.hasDayGrading = sessionTrainee.DayGrading.Comments || (sessionTrainee.DayGrading.GradeType != 'NotSet' && sessionTrainee.DayGrading.Grade) || sessionTrainee.DayGrading.Competences.length>0;
                    $scope.traineeSession.hasReleaseGrading = sessionTrainee.ReleaseGrading.Comments || (sessionTrainee.ReleaseGrading.GradeType != 'NotSet' && sessionTrainee.ReleaseGrading.Grade) || sessionTrainee.ReleaseGrading.Competences.length>0;
                    $scope.traineeSession.AcTypes = [];
                    $scope.traineeSession.AcTypes = [...new Set($scope.traineeSession.Sectors.map(ses => ses.AcType))];
                     //GroupBy AcType
                     $scope.traineeSession.SectorsByAcType = [];
                     $scope.traineeSession.AcTypes.forEach(function(acType){
                         var group = {
                             AcType: acType,
                             Sectors: $scope.traineeSession.Sectors.filter(x => x.AcType == acType)
                         };
                         $scope.traineeSession.SectorsByAcType.push(group);                   
                        });
                } else {
                    trainee.Session = {
                        Released: course.selectedPhase.ModuleType == "Training" ? false : true,
                        CrewId: trainee.CrewId,
                        Items: [],
                        Absent: false,
                        DayGrading: {
                            Comments: null,
                            Grade: null,
                            Competences: []
                        },
                        ReleaseGrading: {
                            Comments: null,
                            Grade: null,
                            Competences: []
                        },                      
                        NeedsAdditionalTraining: false,
                        AdditionalTrainingRemarks: null,
                        CompleteAdditionalTraining: false
                    }
                }
            });
      
            getSelectedPhase($scope.traineeCourse);
    
            var phaseId = $scope.traineeCourse.Phases[0].PhaseId;
            initPhaseDetails(phaseId);
        });
        }
        else {
            $scope.showWarning = true;
            $scope.responseObj;
        }
      
}       
    
  
    function initPhaseDetails(phaseId) {
        $scope.selectedPhase = $scope.courseDetails.CoursePhases.find(x => x.Id == phaseId);

        $scope.traineePhase = $scope.traineeCourse.Phases.find(x => x.PhaseId == phaseId);
        $scope.selectedTraineePhase = $scope.courseDetails.CoursePhases.find(x => x.Id == phaseId);
        $scope.traineeInstructions = $scope.selectedPhase.TraineeInstructions;
        $scope.examinerInstructions = $scope.selectedPhase.ExaminerInstructions;

        $scope.flatSullabusItems = [];
        $scope.traineeCourse.Phases.forEach(function (phase) {
            phase.Sessions.forEach(function (session) {
                session.Items.forEach(function (item) {
                    var flatItem = TrainingSessionFactory.createFlatHistorySullabusItem($scope.traineeCourse, phase, session, item);
                    $scope.flatSullabusItems.push(flatItem);
                });
            });
        });

        $scope.flatCourseSullabusItems = [];
        $scope.courseDetails.CoursePhases.filter(x => x.Syllabus).forEach(function (phase, index, array) {
            phase.Syllabus.ActiveVersion.SyllabusItems.forEach(function (syllabusItem) {
                var syllabusItemHistory = $scope.flatSullabusItems.filter(item => item.ItemId == syllabusItem.Id);
                $scope.flatCourseSullabusItems.push(syllabusItemHistory);
            });

        });
        $scope.isLoading = false;
    }

    function handleFailedResponse(res) {
        $scope.hasError = true;
    }		

    function getSelectedPhase(course) {
        var hasSelectedPhase = false;
        var phases = course.Phases;

        phases.forEach(function (phase, index, array) {
            phase.isFirst = index == 0;
            phase.isLast = (index + 1 == array.length);
            // Select the first InProgress & selected phase
            if (!hasSelectedPhase && phase.Status == "InProgress" && phase.isSelected) {
                phase.Selected = true;
                hasSelectedPhase = true;
            }
        });
        
        // Select the first InProgress phase
        if (!hasSelectedPhase && phases.some(x => x.Status == "InProgress")) {
            phases.find(x => x.Status == "InProgress").Selected = true;
            hasSelectedPhase = true;
        }

        if (!hasSelectedPhase) {
            phases.find(x => x.isFirst).Selected = true;
        }

        $scope.selectedPhase = phases.find(x => x.Selected);
        return $scope.selectedPhase;
    }

    function setSelectedPhase(phaseId){

        $scope.selectedPhase = $scope.courseDetails.CoursePhases.find(x => x.Id == phaseId);
        $scope.courseDetails.CoursePhases.find(x => x.Id == phaseId).Selected = true;
        initPhaseDetails(phaseId);
        return $scope.selectedPhase;
    }

     function gotoCalendar() {
        $location.path("/");
    }

}
})();